import React from 'react';
import ReactDOM from 'react-dom/client';
// Side-effect import: triggers Amplify.configure(outputs) at app startup.
// Required because every feature page is lazy-loaded via React.lazy(), so
// lib/amplify is NOT in the eager import graph reachable from App. Without
// this line, AuthProvider's first getCurrentUser() call runs against an
// unconfigured Amplify singleton and fails with "Auth UserPool not
// configured." Keep this import above ./App.
import './lib/amplify';
import App from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
